<template>
<div class="evaluate">
      <div class="evaluate-headline">
          <p>
            <span >{{this.$t('translateText.StudentEvaluate.pj')}}</span>
            <a-icon type="right" style="margin:0 10px" />
            <span style="color:black" >{{this.eval == "1" ? $t('translateText.StudentEvaluate.wcpj') : $t('translateText.StudentEvaluate.ck') }}</span>
          </p>

          <p @click="revocation"  v-if="this.eval == 2" style="height:100%;display:flex;align-items:center">
            <img style="height:28%;margin-right:10px" src="../../assets/imgs/fanhui.png" alt="">
            <span>{{ this.$t('translateText.swi.back') }}</span>
          </p>
      </div>
      <div class="evaluate-content">
        <p class="title">{{ this.$t('translateText.StudentEvaluate.pjnr') }}</p>
        <p v-for="(item,index) in evaluate" :key="index">
            <span class="content">{{item.evaluationStandard.strStandardContent}}</span>
            <a-divider   style="height:100%" type="vertical" />
            <span class="grade"><a-rate :allowHalf="false" :disabled="compile"  v-model="item.ddEvaluationResult.iNumber" allow-half /></span>
        </p>
      </div>
      <div v-if="this.eval == 1" class="but">
          <one-button @click="revocation">{{ this.$t('translateText.swi.back') }}</one-button>
          <one-button @click="submit">{{ this.$t('translateText.cjtj.qd') }}</one-button>
      </div>
</div>
</template>
<script>
import { getEvaluationResultByUserCourseId,submitCourseEvaluation } from "@/utils/api";

export default {
  data() {
    return {
      compile:true,
      iCourseId:0,
      content:'',
      eval:"",
      evaluate:[],
      evaluationResult:[],
    };
  },
  mounted() {
      this.eval = this.$route.query.iseval  
      if(this.eval == 1){
        this.compile = false
      }
  },
  created(){
    this.getEvaluationInfo();
    
  },
  methods: {
        //获取课程评教详情
    getEvaluationInfo() {
      this.data = [];
      let userCourseId = this.$route.query.userCourseId;
      getEvaluationResultByUserCourseId({
        iUserCourseId: userCourseId,
      }).then((response) => {
        let result = response.data;
        if (result.iCode == 0) {
          // this.loadData(result.objData);
          this.evaluate = result.objData;
        } else {
          this.$message.error(result.strMessage);
        }
      });
    },
    revocation(){
          this.$parent.GetEvaluation()
          // this.$router.push("/StudentEvaluate")
          this.$router.go(-1)
          
    },
    submit(){
      submitCourseEvaluation(
        this.evaluate
      ).then((response)=>{
        if(response.data.iCode == 0){
          this.$parent.GetEvaluation()
          // this.$router.push("/StudentEvaluate")
          this.$router.go(-1)
          
        }
      })
    },
  },
  components: {

  },
};
</script>
<style lang="stylus" scoped>
.evaluate 
  width: 100%;
  height: 100%;
  background-color: white;
  position relative
.evaluate-headline 
  width: 87%;
  height: 10%;
  margin-left 2%
  border-bottom: 2px solid #dadada;
  display flex
  justify-content: space-between
  align-items center
  & span 
    font-weight: 700;
    font-size 16px
  @media (max-width: 1025px) {
    height: 12%;
  }

  @media (max-width: 500px) {
    height: 15%;
  }

.evaluate-content
    overflow: auto;
    width: 87%;
    height: 75%;
    margin-left 2%
    & p
        height 8%
        margin-top 2%
        width 100%
        padding-left 2%
        display flex
        justify-content flex-start
        align-items center
        box-shadow:1px 1px 1px 1px rgba(0,0,0,0.1);
        
.title
    background-color #E5E5E5
    font-size 16px
    font-weight 700
.content
    width 70%
    border-left 5px solid #2faeb6;
    padding-left 1%
    text-align left
.grade
    margin-left 7%
.but
    width 50%
    margin-left 20%
    height 10%
    display flex
    justify-content: space-around;
    align-items center
</style>